// extracted by mini-css-extract-plugin
module.exports = {"instagramWrapper":"hq-z","innerTile":"iq-z","heading":"jq-z","instaTileBtn":"kq-z","disabled":"lq-z","instaTileElement":"mq-z","instagramPic":"nq-z"};